<!-- employee-add-modal.component.html -->
<div class="modal-header">
    <h4 class="modal-title">Dodaj Zaposlenega</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="employeeName" class="form-label">Ime</label>
        <input type="text" id="employeeName" class="form-control" [(ngModel)]="newEmployee.name" name="name">
      </div>
      <div class="mb-3">
        <label for="employeeSurname" class="form-label">Priimek</label>
        <input type="text" class="form-control" id="employeeSurname" [(ngModel)]="newEmployee.surname" name="surname">
      </div>
      <div class="mb-3">
        <label for="employeeDescription" class="form-label">Opis</label>
        <textarea class="form-control" id="employeeDescription" [(ngModel)]="newEmployee.employeeDescription" name="employeeDescription"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Prekliči</button>
    <button type="button" class="btn btn-primary" (click)="addNewEmployee()">Shrani</button>
  </div>
  